import React from 'react';
import { Box, styled } from '@mui/material';
import { useThemeContext } from '../../theme/ThemeContext';

const ToggleWrapper = styled(Box)(({ theme }) => ({
  '.toggle-switch': {
    position: 'relative',
    width: '50px',
    height: '25px',
    '--light': theme.palette.grey[100],
    '--dark': theme.palette.grey[900],
  },

  '.switch-label': {
    position: 'absolute',
    width: '100%',
    height: '25px',
    backgroundColor: 'var(--dark)',
    borderRadius: '12.5px',
    cursor: 'pointer',
    border: '2px solid var(--dark)',
  },

  '.checkbox': {
    position: 'absolute',
    display: 'none',
  },

  '.slider': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '12.5px',
    transition: 'background-color 0.15s ease',
  },

  '.checkbox:checked ~ .slider': {
    backgroundColor: 'var(--light)',
  },

  '.slider::before': {
    content: '""',
    position: 'absolute',
    top: '5px',
    left: '5px',
    width: '12.5px',
    height: '12.5px',
    borderRadius: '50%',
    boxShadow: 'inset 6px -2px 0px 0px var(--light)',
    backgroundColor: 'var(--dark)',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
  },

  '.checkbox:checked ~ .slider::before': {
    transform: 'translateX(25px)',
    backgroundColor: 'var(--dark)',
    boxShadow: 'none',
  },
}));

const ThemeToggle = () => {
  const { mode, toggleColorMode } = useThemeContext();

  return (
    <ToggleWrapper>
      <div className="toggle-switch">
        <label className="switch-label">
          <input 
            type="checkbox" 
            className="checkbox" 
            checked={mode === 'dark'}
            onChange={toggleColorMode}
          />
          <span className="slider" />
        </label>
      </div>
    </ToggleWrapper>
  );
};

export default ThemeToggle; 